var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-td',{attrs:{"props":_vm.props,"hide-title":!_vm.grid}},[_c(_vm.targetComponent,_vm._b({tag:"component"},'component',_vm.targetComponentProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }